// extracted by mini-css-extract-plugin
export const balloonWrapper = "BalloonWrapper__balloonWrapper__3Bmh2";
export const leftArrow = "BalloonWrapper__leftArrow__ZxGUA";
export const downArrow = "BalloonWrapper__downArrow__8xz-x";